import script from "./Tabs.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=ts&generic=T"

const __exports__ = script;

export default __exports__